import { authFetch } from "~/services/fetch";

export async function makeRequestToGetOnMissionProductivity({
  deviceId,
  startDate,
  finishDate,
  agencyIds,
  operationUnitId,
  groupSetId,
  dispatchGroupsId,
  onMissionReasonId,
  exportCSV = false,
}) {
  try {
    const response = await authFetch({
      url: `/report/on-mission-productivity`,
      method: 'POST',
      data: {
        device_id: deviceId,
        start_date: startDate,
        finish_date: finishDate,
        agency_ids: agencyIds,
        operation_unit_id: operationUnitId,
        group_set_id: groupSetId,
        dispatch_group_ids: dispatchGroupsId,
        on_mission_reason_id: onMissionReasonId,
        export_csv: exportCSV,
      }
    });

    return response.data
  } catch (error) {
    console.error('ERROR GENERATE REPORT', error)
    throw error
  }
}